import { render, staticRenderFns } from "./criticalJob.vue?vue&type=template&id=27a256b7"
import script from "./criticalJob.vue?vue&type=script&lang=js"
export * from "./criticalJob.vue?vue&type=script&lang=js"
import style0 from "./criticalJob.vue?vue&type=style&index=0&id=27a256b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports